import React from 'react';
import resume from '../../outerComponents/Pritam_Halder.pdf'
const CTA = () => {
  return (
    <div class="nav-link resume">

    <div className='cta'>
      <div className="nav-link resume" id="resume-button-1">
      <a href={resume} id="resume-link-1" className='btn' target='_blank' download="Pritam-Halder-Resume" onClick={() =>
  window.open(
    "https://drive.google.com/file/d/1DLS0HqF4MBcsZOehqQHw7tvzjIGcAfl1/view?usp=sharing"
  )
}>Download Resume</a>
      </div>
      <a href="#contact" className='btn btn-primary'>Contact</a>
    </div>
    </div>
  );
}

export default CTA;